import './notizie-filters.scss';
import { Translations } from '../utils';

export class NotizieFilters {
  constructor(element) {
    this.element = element || document.querySelector('[data-component="notizie-filters"]');
    if (this.element) {
      this.init();
    }
  }

  init() {
    this.desktopCheckboxes = this.element.querySelectorAll('.notizie-filters__dropdown-list .form-check-input');
    this.checkboxes = this.desktopCheckboxes;
    this.trigger = this.element.querySelector('#categoriesDropdownTrigger');
    this.triggerText = this.trigger ? this.trigger.querySelector('span') : null;
    this.chipsContainer = this.element.querySelector('#activeFiltersContainer');
    this.mobileChipsContainer = this.element.querySelector('.chips-slider');
    this.applyBtn = this.element.querySelector('#categoriesApplyBtn');
    this.mobileApplyBtn = document.getElementById('modalFiltersMobileApplyBtn');
    this.mobileRemoveAllBtn = document.getElementById('modalFiltersMobileRemoveAllBtn');
    this.searchInput = this.element.querySelector('.notizie-filters__input--search');
    this.searchClearBtns = this.element.querySelectorAll('.notizie-filters__input-clear');
    const mobileModal = document.getElementById('modalFiltersMobile');
    const mobileCheckboxes = mobileModal ? mobileModal.querySelectorAll('.form-check-input') : [];
    this.checkboxes = [...this.element.querySelectorAll('.notizie-filters__dropdown-list .form-check-input'), ...mobileCheckboxes];
    this.bindEvents();
    this.updateState();
    this.initDatePicker();
    this.initMobilePeriodModal();
  }

  initMobilePeriodModal() {
    const modal = document.getElementById('modalPeriodMobile');
    if (!modal) return;

    // Elements
    const tabStart = document.getElementById('mobilePeriodTabStart');
    const tabEnd = document.getElementById('mobilePeriodTabEnd');
    const yearDisplay = document.getElementById('mobilePeriodYearSpan');
    const prevYearBtn = document.getElementById('mobilePeriodPrevYearBtn');
    const nextYearBtn = document.getElementById('mobilePeriodNextYearBtn');
    const monthGrid = document.getElementById('mobilePeriodMonthRow');
    const applyBtn = document.getElementById('mobilePeriodApplyBtn');
    const removeAllBtn = document.getElementById('mobilePeriodRemoveAllBtn');

    if (!tabStart || !tabEnd || !yearDisplay || !prevYearBtn || !nextYearBtn || !monthGrid || !applyBtn || !removeAllBtn) {
      return;
    }

    // Inputs
    const startInput = this.element.querySelector('#dateStartInput');
    const endInput = this.element.querySelector('#dateEndInput');

    // State
    let activeTab = 'start'; // 'start' or 'end'
    const tempState = {
      start: { month: null, year: new Date().getFullYear() },
      end: { month: null, year: new Date().getFullYear() },
    };

    // Helper: Parse input value "Month Year"
    const parseValue = (val) => {
      if (!val) return { month: null, year: new Date().getFullYear() };
      const parts = val.split(' ');
      if (parts.length === 2) {
        return { month: parts[0], year: parseInt(parts[1], 10) || new Date().getFullYear() };
      }
      return { month: null, year: new Date().getFullYear() };
    };

    // Helper: Render View
    const render = () => {
      // 1. Tab Styling
      tabStart.classList.toggle('active', activeTab === 'start');
      tabEnd.classList.toggle('active', activeTab === 'end');

      // 2. Year Display
      const currentData = tempState[activeTab];
      yearDisplay.textContent = currentData.year;

      // 3. Month Selection
      const buttons = monthGrid.querySelectorAll('button');
      buttons.forEach((btn) => {
        const m = btn.getAttribute('data-month');
        btn.classList.toggle('active', m === currentData.month);
      });
    };

    // Event: Open Modal
    modal.addEventListener('show.bs.modal', () => {
      // Init temp state from inputs
      tempState.start = parseValue(startInput.value);
      tempState.end = parseValue(endInput.value);
      activeTab = 'start';
      render();
    });

    // Event: Switch Tabs
    tabStart.addEventListener('click', () => {
      activeTab = 'start';
      render();
    });
    tabEnd.addEventListener('click', () => {
      activeTab = 'end';
      render();
    });

    // Event: Year Navigation
    prevYearBtn.addEventListener('click', () => {
      tempState[activeTab].year -= 1;
      render();
    });
    nextYearBtn.addEventListener('click', () => {
      tempState[activeTab].year += 1;
      render();
    });

    // Event: Month Selection
    monthGrid.addEventListener('click', (e) => {
      if (e.target.tagName === 'BUTTON') {
        const month = e.target.getAttribute('data-month');
        tempState[activeTab].month = month;
        render();
      }
    });

    // Event: Apply
    applyBtn.addEventListener('click', () => {
      // Commit start
      if (tempState.start.month) {
        startInput.value = `${tempState.start.month} ${tempState.start.year}`;
      } else {
        startInput.value = '';
      }
      // Commit end
      if (tempState.end.month) {
        endInput.value = `${tempState.end.month} ${tempState.end.year}`;
      } else {
        endInput.value = '';
      }
      this.updateOutput();
    });

    // Event: Remove All
    removeAllBtn.addEventListener('click', () => {
      tempState.start = { month: null, year: new Date().getFullYear() };
      tempState.end = { month: null, year: new Date().getFullYear() };
      render();
    });
  }

  initDatePicker() {
    const startInput = this.element.querySelector('#dateStartInput');
    const startWrapper = this.element.querySelector('#dateStartWrapper');
    const endInput = this.element.querySelector('#dateEndInput');
    const endWrapper = this.element.querySelector('#dateEndWrapper');
    const picker = this.element.querySelector('#genericDatePicker');
    const yearDisplay = this.element.querySelector('#currentYearDisplay');
    const prevYearBtn = this.element.querySelector('#prevYearBtn');
    const nextYearBtn = this.element.querySelector('#nextYearBtn');
    const monthBtns = this.element.querySelectorAll('#genericDatePicker button[data-month]');

    let currentYear = 2025;
    let activeInput = null;

    if (!picker) return;

    const togglePicker = (wrapper, input) => {
      // Move picker to the wrapper's parent (form-group)
      wrapper.parentNode.appendChild(picker);

      if (activeInput === input && picker.classList.contains('is-open')) {
        picker.classList.remove('is-open');
        activeInput = null;
      } else {
        // Reset or Sync state based on input value
        if (!input.value.trim()) {
          // Empty input: Reset to current year and clear selection
          currentYear = new Date().getFullYear();
          if (yearDisplay) yearDisplay.textContent = currentYear;
          monthBtns.forEach((btn) => btn.classList.remove('active'));
        } else {
          // Input has value: Try to parse and sync
          const parts = input.value.split(' ');
          if (parts.length === 2) {
            const monthName = parts[0];
            const year = parseInt(parts[1], 10);

            if (!Number.isNaN(year)) {
              currentYear = year;
              if (yearDisplay) yearDisplay.textContent = currentYear;

              monthBtns.forEach((btn) => {
                if (btn.getAttribute('data-month') === monthName) {
                  btn.classList.add('active');
                } else {
                  btn.classList.remove('active');
                }
              });
            }
          }
        }

        picker.classList.add('is-open');
        activeInput = input;
      }
    };

    // Helper to toggle picker and update ARIA attributes
    const togglePickerWithAria = (wrapper, input) => {
      togglePicker(wrapper, input);
      wrapper.setAttribute('aria-expanded', picker.classList.contains('is-open') ? 'true' : 'false');
    };

    // Toggle picker for start date
    if (startWrapper && startInput) {
      startWrapper.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePickerWithAria(startWrapper, startInput);
      });
      startWrapper.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          togglePickerWithAria(startWrapper, startInput);
        }
      });
    }

    // Toggle picker for end date
    if (endWrapper && endInput) {
      endWrapper.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePickerWithAria(endWrapper, endInput);
      });
      endWrapper.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          togglePickerWithAria(endWrapper, endInput);
        }
      });
    }

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      const isClickInsidePicker = picker.contains(e.target);
      const isClickInsideStart = startWrapper && startWrapper.contains(e.target);
      const isClickInsideEnd = endWrapper && endWrapper.contains(e.target);

      if (!isClickInsidePicker && !isClickInsideStart && !isClickInsideEnd) {
        picker.classList.remove('is-open');
        activeInput = null;
      }
    });

    // Year navigation
    if (prevYearBtn && yearDisplay) {
      prevYearBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        currentYear -= 1;
        yearDisplay.textContent = currentYear;
      });
    }

    if (nextYearBtn && yearDisplay) {
      nextYearBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        currentYear += 1;
        yearDisplay.textContent = currentYear;
      });
    }

    // Month selection
    monthBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const month = btn.getAttribute('data-month');
        if (activeInput) {
          activeInput.value = `${month} ${currentYear}`;
          this.updateOutput();
        }
        picker.classList.remove('is-open');
        activeInput = null;

        // Styling for selected month
        monthBtns.forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
      });
    });
  }

  bindEvents() {
    // Dropdown Checkboxes change
    if (this.checkboxes) {
      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          this.updateCheckboxVisuals();
          const selected = Array.from(this.desktopCheckboxes).filter((cb) => cb.checked);
          this.updateTrigger(selected);
          this.updateOutput();
        });
      });
    }

    // Search Input change
    const searchInputs = this.element.querySelectorAll('.notizie-filters__input--search');
    searchInputs.forEach((input) => {
      input.addEventListener('input', (e) => {
        const { target } = e;
        const { value } = target;
        // Sync all search inputs
        searchInputs.forEach((si) => {
          const inputToSync = si;
          if (inputToSync !== target) inputToSync.value = value;
        });
        // Toggle clear buttons
        this.searchClearBtns.forEach((btn) => {
          const clearBtn = btn;
          clearBtn.classList.toggle('d-none', !value);
        });
        this.updateOutput();
      });
    });

    // Search Clear Button click
    this.searchClearBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        searchInputs.forEach((si) => {
          const inputToClear = si;
          inputToClear.value = '';
        });
        this.searchClearBtns.forEach((b) => {
          const clearBtn = b;
          clearBtn.classList.add('d-none');
        });
        this.updateOutput();
      });
    });

    // Apply Button (Desktop)
    if (this.applyBtn) {
      this.applyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.updateOutput();
        if (this.trigger && typeof bootstrap !== 'undefined') {
          this.trigger.click();
        }
      });
    }

    // Apply Button (Mobile)
    if (this.mobileApplyBtn) {
      this.mobileApplyBtn.addEventListener('click', () => {
        this.updateOutput();
      });
    }

    // Remove All Button (Mobile Modal)
    if (this.mobileRemoveAllBtn) {
      this.mobileRemoveAllBtn.addEventListener('click', () => {
        this.clearAll();
      });
    }

    // Handle 'Rimuovi tutto' click (Page Links)
    const removeAllLinks = this.element.querySelectorAll('.notizie-filters__remove-all');
    removeAllLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.clearAll();
      });
    });

    // Event delegation for dynamically created chips (Desktop & Mobile)
    const handleChipClick = (e) => {
      const btn = e.target.closest('.chip button');
      if (btn) {
        e.preventDefault();
        const valueToRemove = btn.getAttribute('data-value');
        if (valueToRemove === 'dateStart') {
          const startInput = this.element.querySelector('#dateStartInput');
          if (startInput) startInput.value = '';
          this.updateOutput();
        } else if (valueToRemove === 'dateEnd') {
          const endInput = this.element.querySelector('#dateEndInput');
          if (endInput) endInput.value = '';
          this.updateOutput();
        } else if (valueToRemove === 'searchText') {
          searchInputs.forEach((si) => {
            const inputToClear = si;
            inputToClear.value = '';
          });
          this.searchClearBtns.forEach((b) => b.classList.add('d-none'));
          this.updateOutput();
        } else {
          this.deselectOption(valueToRemove);
        }
      }
    };

    if (this.chipsContainer) {
      this.chipsContainer.addEventListener('click', handleChipClick);
    }
    if (this.mobileChipsContainer) {
      this.mobileChipsContainer.addEventListener('click', handleChipClick);
    }
  }

  updateCheckboxVisuals() {
    this.checkboxes.forEach((cb) => {
      const { value } = cb;
      const sameValueCheckboxes = Array.from(this.checkboxes).filter((c) => c.value === value);
      const isAnyChecked = sameValueCheckboxes.some((c) => c.checked);
      // Apply to all
      const checkbox = cb;
      if (checkbox.checked !== isAnyChecked) {
        checkbox.checked = isAnyChecked;
      }
      const wrapper = checkbox.closest('.form-check');
      if (wrapper) {
        if (checkbox.checked) {
          wrapper.classList.add('is-selected');
        } else {
          wrapper.classList.remove('is-selected');
        }
      }
    });
  }

  updateOutput() {
    // Unique selected values
    const uniqueSelected = [];
    const seenValues = new Set();
    this.checkboxes.forEach((cb) => {
      if (cb.checked && !seenValues.has(cb.value)) {
        seenValues.add(cb.value);
        uniqueSelected.push(cb);
      }
    });

    // Add Date chips
    const startInput = this.element.querySelector('#dateStartInput');
    const endInput = this.element.querySelector('#dateEndInput');
    const dateChips = [];
    if (startInput && startInput.value) {
      dateChips.push({
        label: Translations.getLabel('NOTIZIE_FILTERS_DATE_FROM', { value: startInput.value }, `Da ${startInput.value}`),
        value: 'dateStart',
      });
    }
    if (endInput && endInput.value) {
      dateChips.push({
        label: Translations.getLabel('NOTIZIE_FILTERS_DATE_TO', { value: endInput.value }, `A ${endInput.value}`),
        value: 'dateEnd',
      });
    }

    // Add Search chip
    const otherChips = [...dateChips];
    if (this.searchInput && this.searchInput.value.trim()) {
      otherChips.push({ label: this.searchInput.value.trim(), value: 'searchText' });
    }

    this.renderChips(uniqueSelected, otherChips);
  }

  updateState() {
    this.updateCheckboxVisuals();
    const uniqueSelected = [];
    const seenValues = new Set();
    this.checkboxes.forEach((cb) => {
      if (cb.checked && !seenValues.has(cb.value)) {
        seenValues.add(cb.value);
        uniqueSelected.push(cb);
      }
    });
    this.desktopCheckboxes.forEach((cb) => {
      if (cb.checked && !seenValues.has(cb.value)) {
        seenValues.add(cb.value);
      }
    });
    this.updateTrigger(uniqueSelected);
    this.updateOutput();
  }

  updateTrigger(selected) {
    if (!this.trigger || !this.triggerText) return;

    if (selected.length === 0) {
      this.triggerText.textContent = Translations.getLabel('NOTIZIE_FILTERS_TRIGGER_EMPTY', {}, 'Scegli tra le categorie');
      this.trigger.classList.remove('has-selection');
    } else {
      this.triggerText.textContent = Translations.getLabel('NOTIZIE_FILTERS_TRIGGER_SELECTED', { count: selected.length }, `${selected.length} Selezionati`);
      this.trigger.classList.add('has-selection');
    }
  }

  renderChips(selected, dateChips = []) {
    const containers = [];
    if (this.chipsContainer) containers.push(this.chipsContainer);
    if (this.mobileChipsContainer) containers.push(this.mobileChipsContainer);

    containers.forEach((c) => {
      const container = c;
      container.innerHTML = '';
      if (selected.length === 0 && dateChips.length === 0) return;

      // Generate date chips first
      dateChips.forEach((dc) => {
        const chip = document.createElement('div');
        chip.className = container === this.mobileChipsContainer ? 'chip flex-shrink-0' : 'chip';
        const removeFilterAria = Translations.getLabel('NOTIZIE_FILTERS_REMOVE_FILTER_ARIA', { label: dc.label }, `Rimuovi filtro ${dc.label}`);

        const span = document.createElement('span');
        span.textContent = dc.label;
        const button = document.createElement('button');
        button.className = 'btn btn-link';
        button.setAttribute('data-value', dc.value);
        button.setAttribute('aria-label', removeFilterAria);

        button.innerHTML = `
          <svg aria-hidden="true" class="svg-icon">
            <use xlink:href="#sprite-close-circle"></use>
          </svg>
        `;

        chip.appendChild(span);
        chip.appendChild(button);
        container.appendChild(chip);
      });

      // Generate category chips
      selected.forEach((cb) => {
        let label = cb.getAttribute('data-label');
        if (!label) {
          if (cb.nextElementSibling && cb.nextElementSibling.textContent) {
            label = cb.nextElementSibling.textContent;
          } else if (cb.previousElementSibling && cb.previousElementSibling.textContent) {
            label = cb.previousElementSibling.textContent;
          }
        }
        const { value } = cb;
        const chip = document.createElement('div');
        chip.className = container === this.mobileChipsContainer ? 'chip flex-shrink-0' : 'chip';
        const removeFilterAria = Translations.getLabel('NOTIZIE_FILTERS_REMOVE_FILTER_ARIA', { label }, `Rimuovi filtro ${value}`);
        chip.innerHTML = `
          <span>${label}</span>
          <button class="btn btn-link" data-value="${value}" aria-label="${removeFilterAria}">
            <svg aria-hidden="true" class="svg-icon"><use xlink:href="#sprite-close-circle"></use></svg>
          </button>
        `;
        container.appendChild(chip);
      });
      if (container === this.chipsContainer) {
        const removeAllLink = document.createElement('a');
        removeAllLink.href = '#';
        removeAllLink.className = 'notizie-filters__remove-all ms-3 mb-2';
        removeAllLink.textContent = Translations.getLabel('NOTIZIE_FILTERS_REMOVE_ALL', {}, 'Rimuovi tutto');
        removeAllLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.clearAll();
        });
        container.appendChild(removeAllLink);
      }
    });
  }

  deselectOption(value) {
    const targets = Array.from(this.checkboxes).filter((cb) => cb.value === value);
    if (targets.length > 0) {
      targets.forEach((cb) => {
        const checkbox = cb;
        checkbox.checked = false;
      });
      this.updateState();
    }
  }

  clearAll() {
    for (let i = 0; i < this.checkboxes.length; i += 1) {
      this.checkboxes[i].checked = false;
    }

    const searchInputs = this.element.querySelectorAll('.notizie-filters__input--search');
    searchInputs.forEach((si) => {
      const inputToClear = si;
      inputToClear.value = '';
    });
    this.searchClearBtns.forEach((b) => {
      const clearBtn = b;
      clearBtn.classList.add('d-none');
    });

    const startInput = this.element.querySelector('#dateStartInput');
    const endInput = this.element.querySelector('#dateEndInput');
    if (startInput) startInput.value = '';
    if (endInput) endInput.value = '';

    this.updateState();
  }
}
